import { render, staticRenderFns } from "./Paragraph.vue?vue&type=template&id=de95e33e&scoped=true"
import script from "./Paragraph.vue?vue&type=script&lang=js"
export * from "./Paragraph.vue?vue&type=script&lang=js"
import style0 from "./Paragraph.vue?vue&type=style&index=0&id=de95e33e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de95e33e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de95e33e')) {
      api.createRecord('de95e33e', component.options)
    } else {
      api.reload('de95e33e', component.options)
    }
    module.hot.accept("./Paragraph.vue?vue&type=template&id=de95e33e&scoped=true", function () {
      api.rerender('de95e33e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/Paragraph.vue"
export default component.exports